module.exports = "/_next/static/images/Scale@2x-3e0e369692a0a82b6c0681bb3e91251e.png";